import { debounce } from 'lodash';
import { ContentZone, DisplayType, HawksearchGlobal, SearchResponse } from '@models';
import { BaseComponent } from '../base.component';
import { ImageContentComponent } from '../content-types';
import defaultHtml from './content-zone.component.hbs';

declare let Hawksearch: HawksearchGlobal;

export class ZoneComponent extends BaseComponent<SearchResponse> {
    protected override bindEvent = 'hawksearch:bind-content-zone';
    protected override customTemplatePropertyName = 'contentZone';
    protected override defaultHtml = defaultHtml;

    private get name(): string | undefined {
        return this.getAttribute('name') || undefined;
    }

    private get zone(): ContentZone | undefined {
        return this.name ? this.data?.contentZones?.[this.name] : undefined;
    }

    private get displayType(): DisplayType {
        const width = window.innerWidth;

        if (width >= (Hawksearch.config.breakpoints?.desktop ?? 990)) {
            return 'desktop';
        } else if (width >= (Hawksearch.config.breakpoints?.tablet ?? 740)) {
            return 'tablet';
        } else {
            return 'mobile';
        }
    }

    private previousDisplayType?: DisplayType;

    private windowResizeEventHandler!: (event: Event) => void;

    override connectedCallback(): void {
        super.connectedCallback();

        this.windowResizeEventHandler = debounce((event: Event): void => {
            if (this.displayType === this.previousDisplayType) {
                return;
            }

            this.renderContent();
        }, 100);

        window.addEventListener('resize', this.windowResizeEventHandler);
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();

        window.removeEventListener('resize', this.windowResizeEventHandler);
    }

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        this.previousDisplayType = this.displayType;

        if (!this.zone?.items.length) {
            return '';
        }

        const html = template({
            ...this.zone,
            items: this.zone.items.map((i) => i[this.displayType])
        });

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll('[index]').forEach((e) => {
            const component = e as ImageContentComponent;
            const index = parseInt(component.getAttribute('index') || '-1');

            if (isNaN(index) || index < 0 || index >= (this.zone?.items.length || -1)) {
                return;
            }

            component.data = this.zone?.items[index]?.[this.displayType] as any;
        });
    }
}
